<template>
  <modal-base :width="width" no-close-button :heading="text" :line="false">
    <hr />
    <slot>
      <p v-html="subText" />
    </slot>
    <div class="buttons">
      <btn
        :width="110"
        secondary
        v-if="showNoButton"
        @click="$emit('back')"
        :disabled="loading"
        >{{ noButtonText }}</btn
      >
      <btn :width="110" primary @click="$emit('submit')" :loading="loading">{{
        yesButtonText
      }}</btn>
    </div>
  </modal-base>
</template>

<script>
import ModalBase from "Components/Public/ModalBase";
import Btn from "Components/Public/General/Buttons/Btn";
import ButtonsRow from "Components/Public/General/Buttons/ButtonsRow";
export default {
  name: "YesNoModal",
  components: { ButtonsRow, Btn, ModalBase },
  props: {
    text: String,
    subText: String,
    loading: {
      type: Boolean,
      default: false,
    },
    showNoButton: {
      type: Boolean,
      default: true,
    },
    noButtonText: {
      type: String,
      default: "No",
    },
    yesButtonText: {
      type: String,
      default: "Yes",
    },
    width: {
      type: String,
      default: "default",
    },
  },
};
</script>

<style scoped lang="scss">
.buttons {
  display: flex;
  justify-content: space-between;
  align-content: center;
  flex-wrap: wrap;
  min-width: 270px;
  padding: 0 10px 10px 10px;
  width: 100%;
}
</style>
